<div class="overlay" (click)="close()"></div>
<div class="modal">
    <ng-container *ngIf="!reportSuccess">
        <h3 class="modal-title">{{ 'report.title' | translate }}</h3>

        <div class="alert">
            <div class="icon">!</div>
            <div class="alert-content">
                <strong>
                    {{ 'report.alert.title' | translate }}
                </strong>
                <p>
                    {{ 'report.alert.description' | translate }}
                </p>
            </div>
        </div>

        <div class="form-group">
            <label>{{ 'report.form.summary.label' | translate }}</label>
            <input
                type="text"
                [(ngModel)]="summary"
                #summaryRef="ngModel"
                maxlength="255"
            />
        </div>
        <div
            class="error"
            *ngIf="summaryRef.touched && summaryRef.invalid"
        >
            <div *ngIf="summaryRef.errors?.maxlength">
                {{ 'report.form.summary.errorMaxLength' | translate }}
            </div>
        </div>

        <div class="form-group">
            <label>{{ 'report.form.description.label' | translate }}</label>
            <textarea
                rows="4"
                [(ngModel)]="description"
                #descriptionRef="ngModel"
                maxlength="5000"
            ></textarea>
        </div>
        <div
            class="error"
            *ngIf="descriptionRef.touched && descriptionRef.invalid"
        >
            <div *ngIf="descriptionRef.errors?.maxlength">
                {{ 'report.form.description.errorMaxLength' | translate }}
            </div>
        </div>

        <div class="actions">
            <button class="btn cancel" (click)="close()">{{ 'report.button.cancel' | translate }}</button>
            <button class="btn primary" [class.active]="summaryRef.valid && descriptionRef.valid" (click)="report()">{{ 'report.button.report' | translate }}</button>
        </div>
    </ng-container>
    <ng-container *ngIf="reportSuccess">
        <div class="modal-header">
            <span>{{ 'report.success.title' | translate }}</span>
        </div>

        <div class="modal-body">
            <div class="success-icon">✓</div>

            <h3>{{ 'report.success.thankYou' | translate }}</h3>

            <p>
                {{ 'report.success.message' | translate }}
            </p>
        </div>

        <div class="modal-footer">
            <button class="btn primary active" (click)="close()">{{ 'report.button.close' | translate }}</button>
        </div>
    </ng-container>
</div>
